module.exports = __webpack_public_path__ + "img/march_rules.9ac055d1.png";